import { Text } from "@/components/ui/baseUi/text"
import { BoxSlotTemplateEntity } from "@/modules/boxSlotTemplate/entities/boxSlotTemplateEntity"
import { cn } from "@/modules/lib/utils"
import { BoxSlotTemplateForm } from "@modules/boxSlotTemplate/components/boxSlotTemplateForm"
import { word } from "@modules/core/utils/i18n"

export function BoxSlotTemplateFormView({
  boxSlotTemplate,
  boxProgramId,
  dateToCreateSlotTemplateOn,
  className,
  ...props
}: {
  boxSlotTemplate: BoxSlotTemplateEntity | null
  boxProgramId: string
  dateToCreateSlotTemplateOn?: Date
} & React.ComponentProps<"div">) {
  return (
    <div className={cn("flex flex-col gap-4 px-5 pt-18 pb-6", className)} {...props}>
      <div className="flex flex-col gap-12">
        <div className="flex flex-col gap-2">
          <Text fontStyle="TL">
            {boxSlotTemplate
              ? word("programmation.slotTemplates.update_slotTemplate")
              : word("programmation.slotTemplates.create_slotTemplate")}
          </Text>
          <Text fontStyle="BS">{word("programmation.slotTemplates.form.explanation")}</Text>
        </div>

        <BoxSlotTemplateForm
          boxProgramId={boxProgramId}
          boxSlotTemplate={boxSlotTemplate}
          dateToCreateSlotTemplateOn={dateToCreateSlotTemplateOn}
        />
      </div>
    </div>
  )
}
